module.exports = __webpack_public_path__ + "static/img/js_bg_1.ef8b8df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coretesc/js_bg_1.png
// module id = kp35
// module chunks = 1